import { ref, onBeforeMount } from "vue";
import DynamicTable from '../DynamicTable/DynamicTable.vue'
import { isScreenWidth } from "../../foundation/js/is-mobile-device.js";

export default {
  name: "CurrentFundPrices",
  components: {
    DynamicTable,
  },
  props: {
    fundUmbrellas: {
      type: Array,
    },
    baseUrl: {
      type: String,
    },
  },
  setup(props) {
    const tables = ref([])

    const mobileTableGroups = ref([])

    const isError = ref(props.fundUmbrellas.isError)
    const errorMessage = ref(props.fundUmbrellas.errorMessage)
    const hideError = ref(false)

    const isMobile = isScreenWidth("600")

    const populateTables = () => {
      const livePrices = props.fundUmbrellas.livePrices;

      livePrices.forEach(group => {
        const desktop = buildDesktopTable(group)
        const mobile = buildMobileTableGroup(group)

        tables.value.push(desktop)
        mobileTableGroups.value.push(mobile)
      });
    };

    const buildDesktopTable = (group) => {
      const headers = [
        { name: group.header.groupName, scope: 'row' },
        { name: group.header.nav, scope: 'row' },
        { name: group.header.sell, scope: 'row' },
        { name: group.header.buy, scope: 'row' },
        { name: group.header.date, scope: 'row', styles: 'text-right' }
      ]

      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      };

      const rows = group.currentFundPrices.map(fund => [
        { href: `${props.baseUrl}?isin=${fund.isin}&date=${fund.apiDate}` },
        { name: `${fund.isin} ${fund.name ?? ""}` },
        { name: fund.nav },
        { name: fund.sell },
        { name: fund.buy },
        { name: new Date(fund.date).toLocaleString('da-DK', options), styles: 'text-right' }
      ])

      return { headers, rows }
    }

    const buildMobileTableGroup = (group) => {
      const tables = group.currentFundPrices.map(fund => {
        const header = [
          { name: `${fund.isin} ${fund.name}`, scope: 'row', colspan: 3 }
        ]

        const rows = [
          createMobileRow(fund, group.header.nav, fund.nav),
          createMobileRow(fund, group.header.sell, fund.sell),
          createMobileRow(fund, group.header.buy, fund.buy),
          createMobileRow(fund, group.header.date, fund.date)
        ]

        return { headers: header, rows }
      })

      return {
        name: group.header.groupName,
        tables
      }
    }

    function createMobileRow(fund, label, value) {
      return [
        { href: `${props.baseUrl}?isin=${fund.isin}&date=${fund.apiDate}` },
        { name: label },
        { name: value, styles: 'text-right' }
      ];
    }

    const handleHideSystemErrorMessage = () => {
      hideError.value = !hideError.value
    }

    onBeforeMount(() => {
      if (!isError.value) {
        populateTables()
      }
    })

    return {
      hideError,
      isError,
      errorMessage,
      isMobile,
      tables,
      mobileTableGroups,
      handleHideSystemErrorMessage
    }
  },
}
